export type ProductManual = {
  market?: string;
  productId?: number;
  productManualByLanguage?: {
    DE: ProductManualByLanguage;
    EN: ProductManualByLanguage;
    FR: ProductManualByLanguage;
    NL: ProductManualByLanguage;
  };
};

export type ProductManualByLanguage = {
  languageCode: string;
  document?: string;
  description?: string;
  documentName: string;
  showOnWebsite: boolean;
};
